/* eslint-disable spellcheck/spell-checker */
type RecordString = Record<string, string>;

export const TYPE_ICONS: RecordString = {
  formula: 'zkicon icongongshi',
  text: 'zkicon iconwenben',
  integer: 'zkicon iconzhengshu',
  decimal: 'zkicon iconxiaoshu',
  date: 'zkicon iconriqi1',
  datetime: 'zkicon iconshijianriqi',
  'datetime-range': 'zkicon iconshijianriqi',
  'rich-text': 'zkicon iconfuwenben1',
  'long-text': 'zkicon iconfuwenben',
  radio: 'zkicon icondanxuan',
  'single-select': 'zkicon iconxialadanxuan',
  select: 'zkicon iconxialaduoxuan',
  link: 'zkicon iconlianjie',
  labels: 'zkicon iconbiaoqian',
  'progress-bar':'zkicon iconjindutiao',
  member: 'zkicon iconrenyuan'
};

export const FIELD_ICONS: Record<string, string> = {
  subtask: 'zkicon iconzirenwu',
  relationship: 'zkicon iconputongguanlian',
  owner: 'zkicon iconrenyuan',
  follows: 'zkicon iconrenyuan',
  attachment: 'zkicon iconlianjie1',
  comments: 'zkicon iconpinglun-huifu',
  figma:'zkicon iconlianjie',
  labourRecord: 'zkicon iconshengyugongshi',
  estimateLabour: 'zkicon icondianshu',
  docs: 'zkicon iconwendang2'
};
